import axios from 'axios'
import { store } from '../../store/contactAddressStore'
import { selectGroups } from '../../slices/groupSlice'

export const delContactAddress = async (id: number) => {
  const state = store.getState()
  const groups = selectGroups(state)

  const isInGroup = groups.some(group =>
    group.members.some(member => member.id === id)
  )

  if (isInGroup) {
    const message =
      "ユーザーがグループに登録されているため、ユーザーを削除できませんでした。\n" +
      "ユーザーのすべてのグループ所属を解除した後、再度、ユーザーを削除してください";

    const error = new Error(message) as any;
    error.response = {
      status: 409,
      data: { detail: message },
    };
    throw error;
  }
  return await axios.delete(
    `${process.env.REACT_APP_API_URL}/contactAddress/${id}`,
    {
      withCredentials: true,
    },
  )
}

/**
 * 既存ロジック
 */
// import axios from 'axios'

// export const delContactAddress = async (id: number) => {
//   return await axios.delete(
//     `${process.env.REACT_APP_API_URL}/contactAddress/${id}`,
//     {
//       withCredentials: true,
//     },
//   )
// }
